import React, { Component } from 'react';
import { numberWithCommas } from './numberWithCommas';

class CashFormatter extends Component {
  render() {
    const { value, className, style, ezgoFlag } = this.props;
    const priceSymbol = ezgoFlag ? numberWithCommas(value) : `$${numberWithCommas(value)}`
    return <span className={className} style={style}>{ (value !== null && !isNaN(value) && priceSymbol) }</span>;
  }
}

export default CashFormatter;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/cashFormatter.jsx